export const ValidarMembresia = (membresia, entradas) => {
  if (membresia.limit <= 0) {
    return false;
  }

  /*
    let cantidadTotal = 0;
    let total = 0;
    entradas.map((entrada) => {
        if(entrada.quantity){
            cantidadTotal = parseInt(entrada.quantity) + cantidadTotal;
            total = (parseInt(entrada.quantity) * entrada.precio) + total;
        }
    })


    if(total <= 0){
        return false;
    }

    if(membresia.limit < cantidadTotal){
        return false;
    } */

  return true;
};

export const profit = ({ evento, membresia, cupon }) => {
  let totalCupon = null;
  const result = structuredClone(evento);

  if (!membresia) {
    if (cupon.data) {
      if (cupon.data) {
        totalCupon =
          result.info.total - (result.info.total / 100) * cupon.data.descuento;
      }
      let info = {
        ...result.info,
        totalCupon: totalCupon,
      };
      result.info = info;
      return result;
    }
    return result;
  }

  let _total = 0;
  let _subTotal = 0;
  let _serv = 0;
  let limit = membresia.limit;
  let comision = result.evento.comisiones.tasa;
  let entradaMembresia = {};

  let entradas = result.evento.entradas.map((entrada) => {
    if (entrada.hasOwnProperty("quantity")) {
      if (entrada.quantity <= limit) {
        limit = limit - entrada.quantity;
        return {
          ...entrada,
          nombre: `${entrada.nombre} | ${membresia.name}`,
          quantity: entrada.quantity,
          pricexquantity: entrada.quantity * parseFloat(entrada.precio),
          serv:
            ((entrada.quantity * parseFloat(entrada.precio)) / 100) * comision,
          subTotal: entrada.quantity * parseFloat(entrada.precio),
          membresia: membresia.code,
        };
      }

      if (entrada.quantity > limit && limit > 0) {
        entradaMembresia = {
          ...entrada,
          nombre: `${entrada.nombre} | ${membresia.name}`,
          quantity: limit,
          pricexquantity: limit * parseFloat(entrada.precio),
          serv: ((limit * parseFloat(entrada.precio)) / 100) * comision,
          subTotal: limit * parseFloat(entrada.precio),
          membresia: membresia.code,
        };

        let quantity = entrada.quantity - limit;
        let serv = 0;
        let subTotal = 0;
        let pricexquantity = 0;

        pricexquantity = Math.abs(quantity) * parseFloat(entrada.precio);
        subTotal = pricexquantity;
        serv = (pricexquantity / 100) * comision;

        _total = _total + subTotal + serv;
        _subTotal = _subTotal + subTotal;
        _serv = _serv + serv;

        limit = 0;
        return {
          ...entrada,
          quantity: Math.abs(quantity),
          pricexquantity: pricexquantity,
          serv: serv,
          subTotal: subTotal,
        };
      }

      let quantity = entrada.quantity - limit;
      let serv = 0;
      let subTotal = 0;
      let pricexquantity = 0;

      pricexquantity = Math.abs(quantity) * parseFloat(entrada.precio);
      subTotal = pricexquantity;
      serv = (pricexquantity / 100) * comision;

      _total = _total + subTotal + serv;
      _subTotal = _subTotal + subTotal;
      _serv = _serv + serv;

      return {
        ...entrada,
        quantity: Math.abs(quantity),
        pricexquantity: pricexquantity,
        serv: serv,
        subTotal: subTotal,
      };
    } else {
      return entrada;
    }
  });

  entradas.push(entradaMembresia);

  totalCupon = null;
  if (cupon.data) {
    totalCupon = _total - (_total / 100) * cupon.data.descuento;
  }

  let info = {
    serv: _serv,
    subTotal: _subTotal,
    total: _total,
    totalCupon: totalCupon,
  };

  result.evento.entradas = entradas;
  result.info = info;
  return result;
};
